// extracted by mini-css-extract-plugin
export default {"mapWrapper":"Map_mapWrapper__penrB","map":"Map_map__O7yWZ","wrapper":"Map_wrapper__JJU4p","inner":"Map_inner__xgixe","text":"Map_text__T7H7+","link":"Map_link__61Vf1"};